<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('t_bm_serialno')">{{language['common.exportButton']}}</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <!--<a-button type="primary" icon="import">导入</a-button>-->
      </a-upload>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/> 删除 </a-menu-item>&lt;!&ndash;{{language['common.delete']}}&ndash;&gt;
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected"> 清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"

        
        @change="handleTableChange"><!--:rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{language['serialno.noPicture']}}</span>
          <img v-else :src="getImgView(text)" height="25px" :alt="language['serialno.noPicture']" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{language['serialno.noFile']}}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            {{language['download']}}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <tBmSerialno-modal ref="modalForm" @ok="modalFormOk"></tBmSerialno-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TBmSerialnoModal from './modules/TBmSerialnoModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import JInput from '@/components/jeecg/JInput'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  // import JLanguage from '@/components/jeecg/JLanguage'

  export default {
    name: "TBmSerialnoList",
    mixins:[JeecgListMixin],
    components: {
      TBmSerialnoModal
    },
    data () {
      return {
        // 表头
        /**
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.language['common.creator'],
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title:this.language['common.createTime'],
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:this.language['common.modifier'],
            align:"center",
            dataIndex: 'updateBy'
          },
          {
            title:this.language['common.modifyTime'],
            align:"center",
            dataIndex: 'updateTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'单据类别',
            align:"center",
            dataIndex: 'docCat'
          },
          {
            title:'前缀RQ-',
            align:"center",
            dataIndex: 'prefix'
          },
          {
            title:'日期格式yyyyMMdd',
            align:"center",
            dataIndex: 'dateFormat'
          },
          {
            title:'当前日期20200507',
            align:"center",
            dataIndex: 'currDate'
          },
          {
            title:'数据格式0000',
            align:"center",
            dataIndex: 'numberFormat'
          },
          {
            title:'当前编号',
            align:"center",
            dataIndex: 'currNo'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title:'是否有效',
            align:"center",
            dataIndex: 'activeFlag'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ], */
        url: {
          list: "/sys/system/tBmSerialno/list",
          delete: "/sys/system/tBmSerialno/delete",
          deleteBatch: "/sys/system/tBmSerialno/deleteBatch",
          exportXlsUrl: "/sys/system/tBmSerialno/exportXls",
          importExcelUrl: "/sys/system/tBmSerialno/importExcel",
        },
        dictOptions:{},
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.language['common.creator'],
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title:this.language['common.createTime'],
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:this.language['common.modifier'],
            align:"center",
            dataIndex: 'updateBy'
          },
          {
            title:this.language['common.modifyTime'],
            align:"center",
            dataIndex: 'updateTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:this.language['serial.docCat'],
            align:"center",
            dataIndex: 'docCat'
          },
          {
            title:this.language['serial.prefix'],
            align:"center",
            dataIndex: 'prefix'
          },
          {
            title:this.language['serial.dateFormat'],
            align:"center",
            dataIndex: 'dateFormat'
          },
          {
            title:this.language['serial.currentDate'],
            align:"center",
            dataIndex: 'currDate'
          },
          {
            title:this.language['serial.dataFormat'],
            align:"center",
            dataIndex: 'numberFormat'
          },
          {
            title:this.language['serial.currentData'],
            align:"center",
            dataIndex: 'currNo'
          },
          {
            title:this.language['serial.remark'],
            align:"center",
            dataIndex: 'remark'
          },
          {
            title:this.language['serial.activeFlag'],
            align:"center",
            dataIndex: 'activeFlag_dictText'
          },
          {
            title:this.language['common.action'],
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ]
        }
      },

      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>